import React, { useState } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import "./App.css";
import Footer from "./components/footer";
import Top from "./components/Top";
import Particles from "./components/Particles";
import Projects from "./components/Projects";
import Skillscanvas from "./components/Skillscanvas";
import RandomThings from "./components/randomthings";
import TypewriterIntro from "./components/TypewriterIntro";
import Navbar from "./components/navbar";
import GoToTop from "./components/GoToTop";

function App() {
  const [introDone, setIntroDone] = useState(false);

  return (
    <>
      {!introDone && <TypewriterIntro onComplete={() => setIntroDone(true)} />}
      <Router>
        <div className="page-wrapper">
          <Particles>
            <GoToTop />
            <Navbar />
            <div id="home">
              <Top introDone={introDone} />
            </div>
            <br />
            <br />
            <div id="skills">
              <Skillscanvas introDone={introDone} />
            </div>
            <div id="projects">
              <Projects introDone={introDone} />
            </div>
            <RandomThings introDone={introDone} />
            <div id="footer">
              <Footer introDone={introDone} />
            </div>
          </Particles>
        </div>
      </Router>
    </>
  );
}

export default App;